import { Button } from '#components/atoms/buttons/Button.tsx';
import { Code } from '#components/atoms/code/index.ts';
import { TagPill } from '#components/atoms/pill/tag-pill/TagPill.tsx';
import { ConfirmButtonGroup } from '#components/patterns/confirmations/confirm-button-group/ConfirmButtonGroup.tsx';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '#components/patterns/modal/index.ts';
import type { TagName } from '#dn-types/host.ts';

type Props = {
  tagName: TagName;
  onClose: () => void;
};

export function RestartTagModal({ tagName, onClose }: Props) {
  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalHeader>Restart dnclient</ModalHeader>
      <ModalBody>
        {
          <>
            <p className="p">You’ve changed a setting that requires a restart of dnclient.</p>
            <div className="p">
              Please run <Code>dnclient info</Code> on all hosts with <TagPill label={tagName} /> and confirm that your
              changes are applied, then restart dnclient.
            </div>
          </>
        }
      </ModalBody>
      <ModalFooter>
        <ConfirmButtonGroup
          variant="right"
          primaryButton={
            <Button variant="primary" onClick={onClose}>
              OK
            </Button>
          }
        />
      </ModalFooter>
    </Modal>
  );
}
